export const lightTheme = {
  colors: {
    white: "#FFF",
    whitePrimary: "#FFF",
    whiteSecondary: "#FFF",
    greenPrimary: "#013D32",
    greenPrimary2: "#01A998",
    greenPrimary3: "#013D32",
    greenPrimary4: "#013D32",
    greenSecondary: "#03A688",
    grayPrimary: "#585859",
    graySecondary: "#3D3D3D",
    blackPrimary: "#0D0D0D",
    blackPrimary2: "#0D0D0D",
    greenConstrast: "#013d32",
    yellowConstrast: "#FFAE00",
    redConstrast: "#ff2020",
    blueConstrast: "#0033FF",
    blueLightConstrast: "#6688FF",
  },
};

export const darkTheme = {
  colors: {
    white: "#3A3A3A",
    whitePrimary: "#000000",
    whiteSecondary: "#FFF",
    greenPrimary: "#000000",
    greenPrimary2: "#747474",
    greenPrimary3: "#FFF",
    greenPrimary4: "#3A3A3A",
    greenSecondary: "#000000",
    grayPrimary: "#FFF",
    graySecondary: "#FFF",
    blackPrimary: "#FFF",
    blackPrimary2: "#0D0D0D",
    greenConstrast: "#00FF00",
    yellowConstrast: "#FFA500",
    redConstrast: "#C450FF",
    blueConstrast: "#00A7FF",
    blueLightConstrast: "#87CEEB",
  },
};
